import { ActionType, AsyncActionType } from "../types";

export const asyncActionType = (type: ActionType): AsyncActionType => ({
  PENDING: `${type}_PENDING`,
  SUCCESS: `${type}_SUCCESS`,
  ERROR: `${type}_ERROR`,
  RESET: `${type}_RESET`
});

/* API */
export const API_REQUEST: ActionType = 'API_REQUEST';

// Examples
export const GET_COLOUR_PALETTE: AsyncActionType = asyncActionType('GET_COLOUR_PALETTE');

// Authentication
export const LOGIN_AUTH: AsyncActionType = asyncActionType('LOGIN_AUTH');
export const AMPPA_AUTH: AsyncActionType = asyncActionType('AMPPA_AUTH');
export const GET_DASHBOARD_STATS: AsyncActionType = asyncActionType('GET_DASHBOARD_STATS');
export const ROLL_AUTH: AsyncActionType = asyncActionType('ROLL_AUTH');
export const CHECK_USERNAME: AsyncActionType = asyncActionType('CHECK_USERNAME');
export const CHECK_PASSWORD: AsyncActionType = asyncActionType('CHECK_PASSWORD');
export const TOKEN_REFRESH: AsyncActionType = asyncActionType('TOKEN_REFRESH');

export const REGISTER_USER: AsyncActionType = asyncActionType('REGISTER_USER');

export const GET_USER_INFO: AsyncActionType = asyncActionType('GET_USER_INFO');
export const GET_SECURITY_QUESTION: AsyncActionType = asyncActionType('GET_SECURITY_QUESTION');
export const GET_SECURITY_QUESTIONS: AsyncActionType = asyncActionType('GET_SECURITY_QUESTIONS');
export const UPDATE_ACCOUNT_SETTINGS: AsyncActionType = asyncActionType('UPDATE_ACCOUNT_SETTINGS');
export const RESET_UPDATE_ACCOUNT_SETTINGS = "RESET_UPDATE_ACCOUNT_SETTINGS";

export const GET_RFR_NOTICES: AsyncActionType = asyncActionType('GET_RFR_NOTICES');
export const FILE_RFR: AsyncActionType = asyncActionType('FILE_RFR');
export const SUBMIT_RFR: AsyncActionType = asyncActionType('SUBMIT_RFR');
export const TOKEN_SET = "TOKEN_SET";

// Property List
export const GET_PROPERTY_LIST: AsyncActionType = asyncActionType('GET_PROPERTY_LIST');
export const SET_REDIRECTS = 'SET_REDIRECTS';
export const SET_CURRENT_PROPERTY = 'SET_CURRENT_PROPERTY';
export const SET_CURRENT_ADDRESS = 'SET_CURRENT_ADDRESS';
export const SET_CURRENT_OWNERTYPE = 'SET_CURRENT_OWNERTYPE';
export const ADD_PROPERTY: AsyncActionType = asyncActionType('ADD_PROPERTY');
export const ALTERNATE_ADD_PROPERTY_KEY_ID = "ALTERNATE_ADD_PROPERTY_KEY_ID";
export const RESET_ADD_PROPERTY = "RESET_ADD_PROPERTY";
export const REMOVE_PROPERTY: AsyncActionType = asyncActionType('REMOVE_PROPERTY');
export const RESET_REMOVE_PROPERTY = "RESET_REMOVE_PROPERTY";

// Modal
export const CHANGE_MODAL_STATE = 'CHANGE_MODAL_STATE';
export const CHANGE_IS_CLOSEABLE = 'CHANGE_IS_CLOSEABLE';
export const CHANGE_MODAL_CONTENT = 'CHANGE_MODAL_CONTENT';
export const CHANGE_MODAL_ANIMATION = 'CHANGE_MODAL_ANIMATION';

// Current Property Displayer
export const GET_CURRENT_PROPERTY_DETAILS: AsyncActionType = asyncActionType('GET_CURRENT_PROPERTY_DETAILS');

// View Property Details
export const GET_VIEW_PROPERTY_DETAILS: AsyncActionType = asyncActionType('GET_VIEW_PROPERTY_DETAILS');
export const SET_VIEW_PROPERTY_DETAILS: AsyncActionType = asyncActionType('SET_VIEW_PROPERTY_DETAILS');
export const RESET_VIEW_PROPERTY_DETAILS: AsyncActionType = asyncActionType('RESET_VIEW_PROPERTY_DETAILS');

// Tenant Profile
export const GET_TENANT_PROFILE: AsyncActionType = asyncActionType('GET_TENANT_PROFILE');
export const RESET_TENANT_PROFILE: AsyncActionType = asyncActionType('RESET_TENANT_PROFILE');

// Property Documents
export const GET_PROPERTY_DOCUMENTS: AsyncActionType = asyncActionType('GET_PROPERTY_DOCUMENTS');
export const RESET_PROPERTY_DOCUMENTS: AsyncActionType = asyncActionType('RESET_PROPERTY_DOCUMENTS');
export const GET_DOCUMENT: AsyncActionType = asyncActionType('GET_DOCUMENT');
export const RESET_DOCUMENT: AsyncActionType = asyncActionType('RESET_DOCUMENT');

// Reports
export const GET_REPORTS: AsyncActionType = asyncActionType('GET_REPORTS');
export const RESET_REPORTS: AsyncActionType = asyncActionType('RESET_REPORTS');
export const GET_REPORT: AsyncActionType = asyncActionType('GET_REPORT');
export const RESET_REPORT: AsyncActionType = asyncActionType('RESET_REPORT');

//Status Baar
export const GET_AMP_STATUS: AsyncActionType = asyncActionType('GET_AMP_STATUS');
export const UPDATE_AMP_STATUS: AsyncActionType = asyncActionType('UPDATE_AMP_STATUS');

// Toast Notification
export const SET_TOAST_NOTIFICATION = 'SET_TOAST_NOTIFICATION';
export const SET_POPUP_NOTIFICATION = 'SET_POPUP_NOTIF';

export const GET_SNAPSHOTS_LIST: AsyncActionType = asyncActionType('GET_SNAPSHOTS_LIST');
export const GET_SNAPSHOTS_LIST_SILENT: AsyncActionType = asyncActionType('GET_SNAPSHOTS_LIST');
export const RESET_SNAPSHOTS_LIST = 'RESET_SNAPSHOTS_LIST';
export const DOWNLOAD_POI_REPORT: AsyncActionType = asyncActionType('DOWNLOAD_POI_REPORT');
export const GET_POI_VIEW_DATA: AsyncActionType = asyncActionType('GET_POI_VIEW_DATA');
export const RESET_POI_VIEW_DATA: ActionType = "RESET_POI_VIEW_DATA";
export const POI_CUD: AsyncActionType = asyncActionType('POI_CUD');

// Live Chat
export const GET_LIVECHAT_STATUS: AsyncActionType = asyncActionType('GET_LIVECHAT_STATUS');
export const SET_LIVECHAT_STATUS = 'SET_LIVECHAT_STATUS'
// Temp
export const DOWNLOAD_RESIDENTIAL_PROFILE: AsyncActionType = asyncActionType('DOWNLOAD_RESIDENTIAL_PROFILE');
export const RESET_RESIDENTIAL_PROFILE = 'RESET_RESIDENTIAL_PROFILE';
export const GET_SNAPSHOT: AsyncActionType = asyncActionType('GET_SNAPSHOT');
export const RESET_SNAPSHOT = 'RESET_SNAPSHOT';

export const GET_ROLL_NUMBER: AsyncActionType = asyncActionType('GET_ROLL_NUMBER');

// Password Reset
export const BEGIN_PASSWORD_RESET: AsyncActionType = asyncActionType('BEGIN_PASSWORD_RESET');
export const RESET_BEGIN_RESET = "RESET_BEGIN_RESET";
export const SUBMIT_PWD_RESET: AsyncActionType = asyncActionType('BEGIN_PASSWORD_RESET');
export const INIT_PWD_RESET: AsyncActionType = asyncActionType('BEGIN_PASSWORD_RESET');

// Masquerade
export const VALIDATE_MASQUERADE: AsyncActionType = asyncActionType('MASQUERADE');

export const GET_PIER_MESSAGE: AsyncActionType = asyncActionType('GET_PIER_MESSAGE');
export const PIER_TUT_SET = 'PIER_TUT_SET'
// Verify Email
export const VERIFY_EMAIL: AsyncActionType = asyncActionType('VERIFY_EMAIL');
export const VERIFY_EMAIL_RESET = "VERIFY_EMAIL_RESET";
export const RESEND_VERIFY_EMAIL: AsyncActionType = asyncActionType('RESEND_VERIFY_EMAIL');

// Neighbourhood Search
export const SEARCH_CONFIG: AsyncActionType = asyncActionType("SEARCH_CONFIG");
export const AUTOCOMPLETE: AsyncActionType = asyncActionType("AUTOCOMPLETE");
export const NBH_SEARCH: AsyncActionType = asyncActionType("NBH_SEARCH");
export const COORDS: AsyncActionType = asyncActionType("COORDS");
export const ROLLLIST: AsyncActionType = asyncActionType("ROLLLIST");
export const CITYCOORDS: AsyncActionType = asyncActionType("CITYCOORDS");

export const ADD_NEW_POI: ActionType = "ADD_NEW_POI";
export const REM_NEW_POI: ActionType = "REM_NEW_POI";
export const RESET_NEW_POI: ActionType = "RESET_NEW_POI";

// Survey
export const TAKE_SURVEY: AsyncActionType = asyncActionType("TAKE_SURVEY");

// Mailing Address
export const CURRENT_PROP_MAILING_ADDRESS: AsyncActionType = asyncActionType("CURRENT_PROP_MAILING_ADDRESS");
export const CURRENT_ANY_PROP_MAILING_ADDRESS: AsyncActionType = asyncActionType("CURRENT_ANY_PROP_MAILING_ADDRESS");
export const UPDATE_PROP_MAILING_ADDRESS: AsyncActionType = asyncActionType("UPDATE_PROP_MAILING_ADDRESS");

// Enotifications
export const ENOTIFICATION_SUBMIT: AsyncActionType = asyncActionType("ENOTIFICATION_SUBMIT");
